import routerHelperService from './router-helper/router-helper.service';
import userService from './user/user.service';


const coreModule = angular.module('app.core', [
    'ui.router'
]);

// inject services, config, filters and re-usable code
// which can be shared via all modules
coreModule.config(routerHelperService);

coreModule.service('authService', userService);
coreModule.service('dashBoardSeachedList', function() {
    var dataSet = '';
    return {
        getList: function() {
            return dataSet;
        },
        setList: function(newObj) {
            dataSet = newObj;
        }
    }
})
coreModule.service('userEndorseService', function() {
    var dataSet = '';
    return {
        getEndorsedObj: function() {
            return dataSet;
        },
        setEndorsedObj: function(newObj) {
            dataSet = newObj;
        }
    }
})
coreModule.service('CommonFilterRoleService', function() {
    var selected_role = '';
    return {
        getSelectedRole: function() {
            return selected_role;
        },
        setSelectedRole: function(item) {
            selected_role = item;
        }
    }
})
coreModule.service('classStoryServive', function() {
    var dataSet = '', criterias = '', isnewCs = '';
    return {
        getParams: function() {
            return dataSet;
        },
        setParams: function(newObj) {
            dataSet = newObj;
        },
        setSelectedCriterias : function(criteriasParams){
            criterias = criteriasParams
        },
        getSelectedCriterias: function() {
            return criterias;
        },
        getParamsFULL :function() {
            return dataSet;
        },
        setDirectedFromNewCS : function(bool){
            isnewCs = bool
        },
        isRedDirectedFromNewCS : function(){
            return isnewCs
        }
    }
})
coreModule.service('facultyEvalService', function() {
    var dataSet = '', criterias = '', eval_type = '';
    return {
        setSelectedCriterias : function(criteriasParams){
            criterias = criteriasParams
        },
        getSelectedCriterias: function() {
            return criterias;
        },
        setEvalCriteria : function(eval_typeData){
            eval_type = eval_typeData
        },
        getEvalCriteria: function() {
            return eval_type;
        }
    }
})
coreModule.service('uploadService', ['Upload', function(Upload) {
    this.uploadCheckService = function(file, serverUrl, baseUrl, sendUrl, extraInfo = null) {
        this.sucVal = 0;
        Upload.upload({
            url: serverUrl,
            data: {
                file: file,
                "userPath": baseUrl
            }
        }).then(function(resp) {
            var userPathUrl = {};
            userPathUrl.url = resp.data;
            sendUrl(userPathUrl);
            if(!extraInfo || !extraInfo.no_toast){
                toastr.success("Uploaded successfully");
            }
        }, function(resp) {
            toastr.error("Server Unreachable");
        });
    };
    this.uploadToPMS = function(file, serverUrl, baseUrl, sendUrl) {
        this.sucVal = 0;
        Upload.upload({
            url: serverUrl,
            data: {
                file: file,
                "userPath": baseUrl
            }
        }).then(function(resp) {
            var userPathUrl = {};
            userPathUrl.url = resp.data;
            sendUrl(userPathUrl);
            toastr.success("Uploaded successfully");
        }, function(resp) {
            toastr.error("Server Unreachable");
        });
    };
}]);

coreModule.service("setAndSelectStudentRc", function() {
    this.students_selected = '';
    this.set_students_selected = (json) => {
        this.students_selected = json;
    }
    this.get_students_selected = () => {
        return this.students_selected;
    }
})

coreModule.service("navigatePeopleLookUp", function() {
    this.userArray = []
    this.setUserInput = (userDetails) => {
        this.userArray = []
        this.userArray.push(userDetails)
    }
    this.getUserDetails = (userId) => {
        var even = _.find(this.userArray, function(num) {
            return num.user_id == userId;
        })
        return even
    }
})

//Service to generate random color
coreModule.service("randomColorService", function() {
    this.color = [
        "#d1615d",
        "#1a97ab",
        "#37caba",
        "#ff9f00",
        "#b090e3",
        "#47b94a",
        "#ff9f12",
        "#b09063",
        "#47b998"
    ];
    this.getRandomColor = function() {
        return this.color[Math.floor(Math.random() * this.color.length)];

    };
    this.getRandomColorGraph = function() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
})

//To preview file from local if available in local server else from cloud
//Developer - Arul Mozhi J
coreModule.service('filePreviewAvailable', ['CONSTANTS', 'localStorageService', '$http', function(CONSTANTS, localStorageService, $http) {
    this.checkFileExists = function(serverUrl, filePath, callback) {
        try {
            let self = this
            let cloudServerUrl = CONSTANTS.FILE_UPLOAD_URL
            let fileUrl = serverUrl + filePath;
            $http({
                url: fileUrl,
                method: 'HEAD'
            }).then(function() {
                let response = {
                    fileAvaliable: true,
                    fileUrl: fileUrl
                }
                callback(response)
            }, function() {
                if (serverUrl === cloudServerUrl) {
                    let response = {
                        fileAvaliable: false,
                        fileUrl: null
                    }
                    callback(response)
                } else {
                    self.filePreviewUrl('cloud', filePath, function(response) {
                        callback(response)
                    })
                }
            });
        } catch (ex) {
            console.log(ex)
        }
    };
    this.filePreviewUrl = function(server, filePath, callback) {
        try {
            let self = this
            let serverUrl;
            let cloudServerUrl = CONSTANTS.FILE_UPLOAD_URL
            if (server === 'local') {
                let school_id = localStorageService.get('school_id')
                    // Meteor.call("getLocalServerUrl", school_id, (error, result) => {
                    //     if (result && result.value) {
                    //         self.checkFileExists(result.value, filePath, function (response) {
                    //             callback(response)
                    //         })
                    //     } else {
                self.checkFileExists(cloudServerUrl, filePath, function(response) {
                        callback(response)
                    })
                    //     }
                    // })
            } else if (server === 'cloud') {
                self.checkFileExists(cloudServerUrl, filePath, function(response) {
                    callback(response)
                })
            }
        } catch (ex) {
            console.log(ex)
        }
    }
}])
coreModule.service("prevReportService", ['localStorageService', function(localStorageService) {
    let criterias = ''
    this.clearRedirectJson = () => {
        localStorageService.remove('prevReportJson')
    }
    this.setSelectedCriterias = function(criteriasParams){
        localStorageService.set('prevReportJson', criteriasParams)
    },
    this.getSelectedCriterias = function() {
        return localStorageService.get('prevReportJson');
    }
}])
//To set details for archives to load
//Developer - Arul Mozhi J
coreModule.service("archiveService", ['localStorageService', function(localStorageService) {
    this.getRedirectJson = () => {
        return localStorageService.get('redirectJson');
    }
    this.setRedirectJson = (details) => {
        localStorageService.set('redirectJson', details)
    }
    this.clearRedirectJson = () => {
        localStorageService.remove('redirectJson')
    }
}])

coreModule.service('UserPrivilages', ['localStorageService', function(localStorageService) {
    this.modules = '';
    this.features = '';
    this.getAllModules = () => {
        return this.modules;
    }
    this.getFeatures = (module) => {
        let features = _.filter(this.features, function(feature) {
            return feature.module_state == module;
        });
        return features;
    }
    this.getAllFeatures = () => {
        return this.features;
    }
    this.getUserPrivilageInitialSetting = function(callbackResult) {
        var self = this;
        var roleList = localStorageService.get("multiRoles")
        self.modules = localStorageService.get("module_privileges")
        var feature_privileges = localStorageService.get("feature_privileges")
        let featureList = []
        if (roleList.length > 0) {
            _.each(roleList, function(role) {
                var result = _.filter(feature_privileges, function(obj) {
                    return obj.role_id === role
                })
                _.each(result, function(res) {
                    featureList.push(res)
                })
            })
        } else {
            featureList = feature_privileges;
        }
        var finalFeatureList = []
        var groupedFeature = _.groupBy(featureList, function(value) {
            return value.feature_id + '#' + value.module_state;
        });
        _.each(groupedFeature, function(value) {
            var privilegeList = []
            _.each(value, function(each) {
                _.each(each.privilege, function(priv) {
                    privilegeList.push(priv)
                })
            })

            var groupedPrivileges = _.groupBy(privilegeList, 'type');
            var finalPrivilege = []
            _.each(groupedPrivileges, function(privValue, index) {
                var privObj = _.find(privValue, function(stat) {
                    return stat.status == true
                })
                if (privObj) {} else {
                    var privObj = privValue[0]
                }
                finalPrivilege.push(privObj)
            })
            var featureObj = value[0];
            finalFeatureList.push(featureObj)
            featureObj.privilege = finalPrivilege
        })
        self.features = finalFeatureList;
        callbackResult({
            module_privileges: self.modules,
            feature_privileges: self.features
        })
    }
}])

coreModule.service("PDFViewerService", ['$rootScope', function($rootScope) {
    var svc = {};
    var scale;
    var pageNumber;
    var totlaPages, userNotes;
    svc.minPage = function() {
        $rootScope.$broadcast('pdfviewer.minPage')
    };

    svc.nextPage = function() {
        $rootScope.$broadcast('pdfviewer.nextPDFPage');
    };

    svc.prevPage = function() {
        $rootScope.$broadcast('pdfviewer.prevPDFPage');
    };

    svc.fitPage = function() {
        $rootScope.$broadcast('pdfviewer.setFitPDFPage');
    };

    svc.getScale = function() {
        $rootScope.$broadcast('pdfviewer.getScale');
        return this.scale;
    };

    svc.getPageNumber = function() {
        $rootScope.$broadcast('pdfviewer.getPageNumber');
        return this.pageNumber;
    };
    svc.getTotalPageNumber = function() {
        $rootScope.$broadcast('pdfviewer.getTotalPageNumber');
        return this.totlaPages;
    };

    svc.setPageNumber = function(pageNum) {
        this.pageNumber = pageNum
    };
    svc.setTotalPageNumber = function(totalPageNum) {
        this.totlaPages = totalPageNum
    };
    svc.setScale = function(scale) {
        this.scale = scale
    };
    svc.setUserNotes = function(note) {
        this.userNotes = note;
    };
    svc.getUserNotes = function() {
        return this.userNotes;
    };
    svc.Instance = function(id) {
        var instance_id = id;

        return {
            prevPage: function() {
                $rootScope.$broadcast('pdfviewer.prevPage', instance_id);
            },
            nextPage: function() {
                $rootScope.$broadcast('pdfviewer.nextPage', instance_id);
            },
            gotoPage: function(page) {
                $rootScope.$broadcast('pdfviewer.gotoPage', instance_id, page);
            },
            zoomIn: function() {
                $rootScope.$broadcast('pdfviewer.zoomIn', instance_id);
            },
            zoomOut: function() {
                $rootScope.$broadcast('pdfviewer.zoomOut', instance_id);
            },
            fitPage: function() {
                $rootScope.$broadcast('pdfviewer.setFitPage', instance_id);
            },
        };
    };

    return svc;
}]);

/* --------------- Services ends --------------- */

/* --------------- Factories starts --------------- */

coreModule.factory('AppInterceptor', ['$q', '$location', function($q, $location) {
    return {
        'responseError': function(rejection) {
            var defer = $q.defer();
            if (rejection.status == 401) {
                $location.path('/login');
            }
            defer.reject(rejection);
            return defer.promise;
        }
    };
}]);

/* @Author: Sree Swathy S  @Date: 2018-05-16  @Desc: Function for checking school logo */
coreModule.factory('SchoolLogo', function(CONSTANTS) {
    var checkLogofactory = {}
    checkLogofactory.checkLogo = function(image_url) {
        try {
            var http = new XMLHttpRequest();
            http.open('HEAD', image_url, false);
            http.send();
            if (http.status == 200) {
                return image_url;
            } else {
                return CONSTANTS.DEFAULT_SCHOOL_LOGO;
            }
        } catch (ex) {
            return CONSTANTS.DEFAULT_SCHOOL_LOGO;
        }
    };
    return checkLogofactory
});
/* End */
coreModule.factory('ProfileImage', function(CONSTANTS) {
    var checkLogofactory = {}
    checkLogofactory.checkLogo = function(image_url) {
        try {
            var http = new XMLHttpRequest();
            http.open('HEAD', image_url, false);
            http.send();
            if (http.status == 200) {
                return image_url;
            } else {
                return CONSTANTS.DEFAULT_PROFILE_IMAGE;
            }
        } catch (ex) {
            return CONSTANTS.DEFAULT_PROFILE_IMAGE;
        }
    };
    return checkLogofactory
});

/** @Author: Naveen Nazimudeen N  @Date: 2018-02-07 19:30:02  @Desc:Function for error validation factory  */
coreModule.factory('errorValidatorUtil', function() {
        var errorValidatorUtil = {};
        errorValidatorUtil.assignErrorValue = assignErrorValue;
        return errorValidatorUtil;
    })
    /* End */

//Factory for auth settings - Arul Mozhi J
coreModule.factory('menuHeaderService', ["localStorageService", "$rootScope", function(localStorageService, $rootScope) {
    return {
        authMenu: this.authMenu,
        setAuthMenu: function() {
            this.authMenu = true
        },
        setDefault: function() {
            console.log(localStorageService.get("authoringData"))
            if (localStorageService.get("authoringData")) {
                this.authMenu = true
                $rootScope.authMenu = true;
            } else {
                this.authMenu = false
                $rootScope.authMenu = false;
            }

        },
        destroySession: function() {
            localStorageService.keys().forEach(function(key) {
                console.log(key)
                let notClearSessions = [
                    'is_login', 
                    'activeAcdYear', 
                    'academic_year', 
                    'current_Page', 
                    'feature_privileges', 
                    'full_name', 
                    'module_privileges',
                    'role_ids', 
                    'school_id', 
                    'user_id', 
                    'user_image', 
                    'username', 
                    'login_timestamp'
                ]
                if (_.contains(notClearSessions, key)) {} else {
                    localStorageService.remove(key);
                }
            })
        },
        exitFromAuthoring: function() {
            this.destroySession()
            this.setDefault()
        }
    }
}])

coreModule.factory('AnnouncementUsers', function() {
    let usersIds = {}
    return {
        addAnnouncement: function(data,stdids) {
            this.usersIds = data
            this.studentsIds = stdids
        },
        getAnnouncement: function() {
            return usersIds;
        }
    }
})

coreModule.factory('matomoEventTrack', function () {
    return {
        pushEvent: function (category, action, name, value) {
            try {
                _paq.push(['trackEvent', category, action, name, value]);
            } catch (e) {
                console.log(e);
            }
        },
    }
})

/* --------------- Factories ends --------------- */

/* --------------- Directives starts --------------- */
coreModule.directive('stopccp', function(){
    return {
        scope: {},
        link:function(scope,element){
            element.on('cut copy paste', function (event) {
              event.preventDefault();
              toastr.error("Sorry, This operation is not permitted");
            });
        }
    };
});
coreModule.directive('numbersOnly', function() {
    return {
        require: 'ngModel',
        link: function(scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
})

coreModule.directive('repeatDone', function() {
    return function(scope, element, attrs) {
        if (scope.$last) { // all are rendered
            scope.$eval(attrs.repeatDone);
        }
    }
})

coreModule.directive('decimalNumbersOnly', function() {
    return {
        require: 'ngModel',
        link: function(scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9.]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
})

coreModule.directive("errorMsg", function() {
    let directive = {};
    directive.restrict = "E";
    directive.template = '<i class="md-accent">{{msg}}</i>';
    directive.scope = {
        msg: "=msg"
    }
    return directive;
})

coreModule.directive('onError', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attr) {
            element.on('error', function() {
                element.attr('src', attr.onError);
            })
        }
    }
})

coreModule.directive('hcChart', function() {
    return {
        restrict: 'E',
        template: '<div></div>',
        scope: {
            options: '='
        },
        link: function(scope, element) {
            Highcharts.chart(element[0], scope.options);
        }
    };
})

coreModule.directive("multiScroll", function() {
    return {
        restrict: 'AE',
        scope: {
            loading: "@",
            whenScrolled: '&whenscroll'
        },
        link: function(scope, elem, attrs) {
            elem.bind("scroll", function() {
                var raw = elem[0];
                if (raw.scrollTop + raw.clientHeight >= raw.scrollHeight) {
                    scope.whenScrolled();
                }
            });
        }
    }
})

coreModule.filter('hhmmss', function() {
    return function(time) {
        var sec_num = parseInt(time, 10); // don't forget the second param
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        var time = hours + ':' + minutes + ':' + seconds;
        return time;
    }
})

coreModule.directive('userAvatar', function() {
    return {
        link: function(scope, element, attrs) {

            var placeholder = '../../img/icons/ic_person_black.svg';
            //var placeholder = '../../img/images/profile-pic.png';

            scope.$watch(function() {
                return attrs.ngSrc;
            }, function(value) {
                if (!value) {
                    element.attr('src', placeholder);
                }
            });

            element.bind('error', function() {
                element.attr('src', placeholder);
            });
        }
    }
})

coreModule.directive('starRating', function() {
    return {
        restrict: 'A',
        template: '<ul class="rating">' +
            '<li ng-repeat="star in stars" ng-class="star">' +
            '\u2605' +
            '</li>' +
            '</ul>',
        scope: {
            ratingValue: '=',
            max: '='
        },
        link: function(scope, elem, attrs) {
            scope.stars = [];
            for (var i = 0; i < scope.max; i++) {
                scope.stars.push({
                    filled: i < scope.ratingValue
                });
            }
        }
    }
});

coreModule.directive('pdfviewer', ['$parse', function($parse, PDFViewerService, $location, $state) {
    var canvas = null;
    var instance_id = null;

    return {
        restrict: "E",
        template: '<canvas style="height:100%;width:100%" ></canvas>',
        scope: {
            onPageLoad: '&',
            loadProgress: '&',
            src: '@',
            id: '='
        },

        controllerAs: "pdfUrlCtrller",
        controller: ['$scope', 'PDFViewerService', '$state', '$mdToast', function($scope, PDFViewerService, $state, $mdToast) {
            $scope.pageNum = 1;
            $scope.pdfDoc = null;
            $scope.scale = 1.0;
            $scope.pageFit = true
            let BASE64_MARKER = ';base64,';

            function convertDataURIToBinary(dataURI) {
                var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
                var base64 = dataURI.substring(base64Index);
                var raw = window.atob(base64);
                var rawLength = raw.length;
                var array = new Uint8Array(new ArrayBuffer(rawLength));

                for (var i = 0; i < rawLength; i++) {
                    array[i] = raw.charCodeAt(i);
                }
                return array;
            }

            function convertDataURIToBinaryLocal(dataURI) {
                // var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
                // var base64 = dataURI.substring(base64Index);
                // var raw = window.atob(base64); 
                var raw = dataURI
                var rawLength = raw.length;
                var array = new Uint8Array(new ArrayBuffer(rawLength));
                for (var i = 0; i < rawLength; i++) {
                    array[i] = raw.charCodeAt(i);
                }
                return array;
            }

            $scope.documentProgress = function(progressData) {
                if ($scope.loadProgress) {
                    $scope.loadProgress({
                        state: "loading",
                        loaded: progressData.loaded,
                        total: progressData.total
                    });
                }

            };
            $scope.loadPDF = function(path, initPage) {

                pdfjsLib.getDocument(path).then(function(_pdfDoc) {
                    $scope.$parent.showLoadingFirst = false

                    $scope.pdfDoc = _pdfDoc;
                    if (initPage) {
                        $scope.pageNum = initPage
                    }
                    $scope.renderPage($scope.pageNum, function(success) {
                        if ($scope.loadProgress) {
                            $scope.loadProgress({
                                state: "finished",
                                loaded: 0,
                                total: 0
                            });
                        }
                    });
                }, function(message, exception) {
                    if (message.status === 0) {
                        toastr.error($mdToast, "Unable to connect the file server, please contact your system admin", 'error-toast');
                        //$state.go("additionalResourcesTile"); // commented by jishnu since its not yet defined in the project
                        return;
                    }
                    if ($scope.loadProgress) {
                        $scope.loadProgress({
                            state: message,
                            loaded: 0,
                            total: 0
                        });
                    }
                });
            };
            $scope.loadPDFData = function(data, initPage) {
                let pdfAsDataUri = "data:application/pdf;base64," + data; // shortened
                let pdfAsArray = convertDataURIToBinary(pdfAsDataUri);
                //PDFJS.getDocument(pdfAsArray)
                pdfjsLib.getDocument(pdfAsArray, null, null, $scope.documentProgress).then(function(_pdfDoc) {
                    $scope.pdfDoc = _pdfDoc;
                    if (initPage) {
                        $scope.pageNum = initPage
                    }
                    $scope.renderPage($scope.pageNum, function(success) {
                        if ($scope.loadProgress) {
                            $scope.loadProgress({
                                state: "finished",
                                loaded: 0,
                                total: 0
                            });
                        }
                    });
                }, function(message, exception) {
                    if ($scope.loadProgress) {
                        $scope.loadProgress({
                            state: "error",
                            loaded: 0,
                            total: 0
                        });
                    }
                });
            };
            $scope.loadPDFDatalocal = function(data, initPage) {
                // let pdfAsDataUri = "data:application/pdf;base64," + data; // shortened
                // 
                let pdfAsArray = convertDataURIToBinaryLocal(data);
                //PDFJS.getDocument(pdfAsArray)
                pdfjsLib.getDocument(pdfAsArray, null, null, $scope.documentProgress).then(function(_pdfDoc) {
                    $scope.$parent.showLoadingFirst = false
                    $scope.pdfDoc = _pdfDoc;
                    if (initPage) {
                        $scope.pageNum = initPage
                    }
                    $scope.renderPage($scope.pageNum, function(success) {
                        if ($scope.loadProgress) {
                            $scope.loadProgress({
                                state: "finished",
                                loaded: 0,
                                total: 0
                            });
                        }
                    });
                }, function(message, exception) {
                    if ($scope.loadProgress) {
                        $scope.loadProgress({
                            state: "error",
                            loaded: 0,
                            total: 0
                        });
                    }
                });
            };


            $scope.backingScale = function() {
                var ctx = canvas.getContext('2d');
                var dpr = window.devicePixelRatio || 1;
                var bsr = ctx.webkitBackingStorePixelRatio ||
                    ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio ||
                    ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;

                return dpr / bsr;
            };
            $scope.renderPage = function(num, callback) {
                if ($scope.$parent.pageEnd < num) {
                    return false;
                }
                if ($scope.$parent.pageStart > num) {

                    return false;
                }

                // sendTinCanApiStatement($scope.$parent, num)
                $scope.pdfDoc.getPage(num).then(function(page) {
                    var viewport, pageWidthScale;
                    if ($scope.pageFit) {
                        viewport = page.getViewport(1);
                        var clientRect = canvas.getBoundingClientRect();
                        pageWidthScale = clientRect.width / viewport.width;
                        $scope.scale = pageWidthScale;
                    }

                    viewport = page.getViewport($scope.scale);
                    var ctx = canvas.getContext('2d');
                    var ratio = $scope.backingScale()
                        //canvas.height = viewport.height;
                        //canvas.width = viewport.width;
                    var w = viewport.width
                    var h = viewport.height
                    canvas.width = Math.floor(w * ratio);
                    canvas.height = Math.floor(h * ratio);
                    canvas.style.width = Math.floor(w) + 'px';
                    canvas.style.height = Math.floor(h) + 'px';

                    canvas.getContext('2d').setTransform(ratio, 0, 0, ratio, 0, 0);

                    page.render({
                        canvasContext: ctx,
                        viewport: viewport
                    }).promise.then(
                        function() {
                            if (callback) {
                                callback(true);
                            }
                            $scope.$apply(function() {
                                $scope.onPageLoad({
                                    page: $scope.pageNum,
                                    total: $scope.pdfDoc._pdfInfo.numPages
                                });
                            });
                        },
                        function() {
                            if (callback) {
                                callback(false);
                            }
                        }
                    );
                });
            };

            $scope.count = 0;

            function timer() {
                $scope.count = $scope.count + 1;

            }

            $scope.$on('pdfviewer.nextPage', function(evt, id) {
                if (id !== instance_id) {
                    return;
                }
                if ($scope.$parent.pageEnd < ($scope.pageNum + 1)) {
                    return false;
                }
                if ($scope.pageNum < $scope.pdfDoc._pdfInfo.numPages) {
                    $scope.pageNum++;
                    $scope.renderPage($scope.pageNum);
                }
            });
            $scope.$on('pdfviewer.prevPage', function(evt, id) {
                if (id !== instance_id) {
                    return;
                }
                if ($scope.$parent.pageStart > ($scope.pageNum - 1)) {
                    return false;
                }
                if ($scope.pageNum > 1) {
                    $scope.pageNum--;
                    $scope.renderPage($scope.pageNum);
                }
            });
            $scope.$on('pdfviewer.nextPDFPage', function(evt, id) {
                /*if (id !== instance_id) {
                    return;
                }*/
                if ($scope.$parent.pageEnd < ($scope.pageNum + 1)) {
                    return false;
                }
                if ($scope.pageNum < $scope.pdfDoc._pdfInfo.numPages) {
                    $scope.pageNum++;
                    $scope.renderPage($scope.pageNum);
                }
            });
            $scope.$on('pdfviewer.prevPDFPage', function(evt, id) {
                /*if (id !== instance_id) {
                    return;
                }*/
                if ($scope.$parent.pageStart > ($scope.pageNum - 1)) {
                    return false;
                }
                if ($scope.pageNum > 1) {
                    $scope.pageNum--;
                    $scope.renderPage($scope.pageNum);
                }
            });
            $scope.$on('pdfviewer.gotoPage', function(evt, id, page) {
                if (id !== instance_id) {
                    return;
                }
                if (page >= 1 && page <= $scope.pdfDoc._pdfInfo.numPages) {
                    $scope.pageNum = page;
                    $scope.renderPage($scope.pageNum);
                }
                /*if (page >= 1 && page <= 5 - 1) {
                    $scope.pageNum = page;
                    $scope.renderPage($scope.pageNum);
                }*/
            });
            $scope.$on('pdfviewer.zoomIn', function(evt, id) {
                if (id !== instance_id) {
                    return;
                }
                $scope.pageFit = false
                $scope.scale = parseFloat($scope.scale) + 0.2;
                $scope.renderPage($scope.pageNum);
            });
            $scope.$on('pdfviewer.setFitPage', function(evt, id) {
                if (id !== instance_id) {
                    return;
                }
                $scope.pageFit = true
                $scope.scale = 1.0
                $scope.renderPage($scope.pageNum);
            });

            $scope.$on('pdfviewer.setFitPDFPage', function(evt) {
                /*if (id !== instance_id) {
                    return;
                }*/
                $scope.pageFit = true
                $scope.scale = 1.0
                $scope.renderPage($scope.pageNum);
            });

            $scope.$on('pdfviewer.zoomOut', function(evt, id) {
                if (id !== instance_id) {
                    return;
                }
                $scope.pageFit = false
                $scope.scale = parseFloat($scope.scale) - 0.2;
                $scope.renderPage($scope.pageNum);
            });
            $scope.$on('pdfviewer.getScale', function(evt) {

                PDFViewerService.setScale($scope.scale);
            });
            $scope.$on('pdfviewer.getPageNumber', function(evt) {

                PDFViewerService.setPageNumber($scope.pageNum);
            });
            $scope.$on('pdfviewer.getTotalPageNumber', function(evt) {

                PDFViewerService.setTotalPageNumber($scope.pdfDoc.numPages);
            });

        }],
        link: function(scope, iElement, iAttr) {
            canvas = iElement.find('canvas')[0];
            instance_id = iAttr.id;
            iAttr.$observe('src', function(v, p) {
                if (v !== undefined && v !== null && v !== '') {
                    scope.pageNum = 1;
                    if (scope.src.length > 200) {
                        if (scope.$parent.additionalResourcesPdfLoad) {
                            scope.loadPDFDatalocal(scope.src, scope.$parent.pageStart);
                        } else {
                            scope.loadPDFData(scope.src, scope.$parent.pageStart);
                        }
                    } else {
                        scope.loadPDF(scope.src, scope.$parent.pageStart);
                    }
                    //scope.loadPDF(scope.src, scope.$parent.pageStart);/uploads/pdfsingle/file-1469271850767.pdf
                }
            });
        }
    };
}])

coreModule.directive('ngEnter', function() {
    return function(scope, element, attrs) {
        element.bind("keydown keypress", function(event) {
            if (event.which === 13) {
                scope.$apply(function() {
                    scope.$eval(attrs.ngEnter);
                });

                event.preventDefault();
            }
        });
    };
});

/* --------------- Directives ends --------------- */


/** @Author: Naveen Nazimudeen N  @Date: 2018-02-07 19:28:47  @Desc: Function for error validation factory  */
function assignErrorValue(obj, keyPath, value) {
    let lastKeyIndex = keyPath.length - 1;
    for (var i = 0; i < lastKeyIndex; ++i) {
        let key = keyPath[i];
        if (!(key in obj))
            obj[key] = {}
        obj = obj[key];
    }
    obj[keyPath[lastKeyIndex]] = value;
}

export default coreModule;


// WEBPACK FOOTER //
// ./src/services/core.module.js